import { useState } from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Hier kommt später die Formular-Verarbeitung
    console.log('Form submitted:', formData);
  };

  const socialLinks = [
    {
      platform: 'Instagram',
      icon: '📸',
      handle: '@angeldevilnetwork',
      url: 'https://instagram.com/angeldevilnetwork'
    },
    {
      platform: 'Twitter',
      icon: '🐦',
      handle: '@angeldevilnet',
      url: 'https://twitter.com/angeldevilnet'
    },
    {
      platform: 'TikTok',
      icon: '🎵',
      handle: '@angeldevilnetwork',
      url: 'https://tiktok.com/@angeldevilnetwork'
    }
  ];

  return (
    <div className="pt-20 w-full">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-none text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Kontakt – <span className="text-gradient">Sprich mit uns</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8 max-w-4xl mx-auto">
              Du hast Fragen, möchtest mehr über uns erfahren oder dich direkt anmelden? 
              Wir sind für dich da! Kontaktiere uns ganz einfach über die unten stehenden Möglichkeiten.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 w-full">
        <div className="container-custom">
          <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
            {/* Contact Form */}
            <div className="xl:col-span-3">
              <div className="relative h-full">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8 h-full">
                  <h2 className="text-2xl sm:text-3xl font-playfair text-gradient mb-8">Schreib uns eine Nachricht</h2>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label htmlFor="name" className="block text-white mb-2">Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-white mb-2">E-Mail-Adresse</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="subject" className="block text-white mb-2">Betreff</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="message" className="block text-white mb-2">Nachricht</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="8"
                        className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                        required
                      ></textarea>
                    </div>
                    <button type="submit" className="btn-primary w-full">
                      Nachricht senden 🚀
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* Contact Info & Social */}
            <div>
              <div className="relative mb-8">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl font-playfair text-gradient mb-6">Kontaktinformationen</h2>
                  <div className="space-y-4 text-white/80">
                    <p>
                      <span className="block font-medium text-white">E-Mail:</span>
                      <a
                        href="mailto:info@angel-devil.network"
                        className="hover:text-hot-pink transition-colors"
                      >
                        info@angel-devil.network
                      </a>
                    </p>
                    <p>
                      <span className="block font-medium text-white">Telefon:</span>
                      <a
                        href="tel:+13057776989"
                        className="hover:text-hot-pink transition-colors"
                      >
                        +1 (305) 777-6989
                      </a>
                    </p>
                    <div>
                      <span className="block font-medium text-white mb-2">Adresse:</span>
                      <p>Angel & Devil Agency LLC</p>
                      <p>7901 4th St N</p>
                      <p>St. Petersburg, FL 33702</p>
                      <p>USA</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl font-playfair text-gradient mb-6">Social Media</h2>
                  <p className="text-white/80 mb-6">Folge uns für Updates, Tipps und Neuigkeiten:</p>
                  <div className="space-y-4">
                    {socialLinks.map((social, index) => (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-4 p-4 rounded-xl bg-deep-black/50 hover:bg-deep-black/70 transition-colors group"
                      >
                        <span className="text-2xl group-hover:scale-110 transition-transform">{social.icon}</span>
                        <div>
                          <p className="text-white/60">{social.platform}</p>
                          <p className="text-hot-pink group-hover:text-accent-purple transition-colors">{social.handle}</p>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 w-full">
        <div className="container-custom">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
            <div className="relative glass-effect rounded-2xl p-12">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
                <div className="lg:col-span-2">
                  <h2 className="text-2xl sm:text-3xl font-playfair mb-4">
                    Direkt loslegen?
                  </h2>
                  <p className="text-xl text-white/90">
                    Du bist bereit, Teil des Angel & Devil Networks zu werden?
                  </p>
                </div>
                <div className="flex justify-center lg:justify-end">
                  <div className="mt-8 text-center">
                    <Link
                      to="/bewerbung"
                      className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition duration-300 inline-block"
                    >
                      Jetzt Anmelden
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
